import styled from "styled-components";

export const Message = styled.div``;

export const Actions = styled.div`
    margin-top: 1em;
`;

export const MessageWrapper = styled.div`
    text-align: center;
    padding: 6em 0;
    display: grid;
    justify-content: center;
    align-content: center;
    ${Message} {
    }
    ${Actions} {
    }
`;

export const FooterContainer = styled.div`
    padding-top: 100px;
`;
